<script>
import { computed, getCurrentInstance, ref, onMounted, provide, nextTick } from 'vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import OpeningAnimation from '@rebuild/materials/shared/layout_wrapper/surf/OpeningAnimation.vue';
import { useBusEvent } from '@rebuild/hooks/useBusEvent';
import { useStore } from '@/utils/vue-api';
import { isOverviewMenu } from '@rebuild/materials/shared/layout_nav/surf/useNavMenu';
import eventBus from '@rebuild/utils/event-bus';
import { INJECT_KEY_OPENING_COMPLETE } from '@rebuild/materials/shared/page_container/useDisplayLogic';
import { useMenuTree } from '@rebuild/hooks/useMenuTree';

export default {
	name: 'SurfLayoutWrapper',
	components: {
		SmartLayoutC,
		OpeningAnimation
	},
	setup() {
		const vm = getCurrentInstance();
		const store = useStore();
		const inPageView = computed(() => vm.proxy.$route.meta?.source === 'page');

		const openingComplete = ref(false);
		provide(INJECT_KEY_OPENING_COMPLETE, openingComplete);

		const openingAnimationRef = ref(null);
		onMounted(async () => {
			await nextTick();
			const openingAnimation = openingAnimationRef.value;
			openingAnimation?.init();

			await new Promise(resolve => setTimeout(resolve, 300)); // 缓冲一下字体包加载
			if (openingAnimation) {
				openingAnimation.play();
			}
		});
		const handleOpeningComplete = () => {
			openingComplete.value = true;
		};

		const { getMenuByUuid } = useMenuTree();

		// 监听模板数据变化 更新视图
		useBusEvent('iframe-message', msgData => {
			const { iframePreviewData, uuid, activeModuleId } = msgData;

			if (typeof iframePreviewData != 'undefined') {
				// 更新模板数据
				store.commit('setCommonData', {
					data: iframePreviewData,
					overwrite: true
				});
			}
			if (uuid) {
				const findMenu = getMenuByUuid(uuid);
				const findMenuItem = findMenu?.meta || null;

				if (findMenuItem) {
					const currentRoute = vm.proxy.$route;
					const { name, params, query } = currentRoute;

					const combinedParams = { ...params, menuId: findMenuItem.uuid };
					if (!isOverviewMenu(findMenuItem) && activeModuleId) {
						combinedParams.moduleId = activeModuleId;
					} else {
						// 避免 moduleId 污染
						delete combinedParams.moduleId;
					}

					const options = {
						name,
						params: combinedParams,
						query
					};
					vm.proxy.$router.push(options).then(() => {
						eventBus.emit('once-message', { activeModuleId });
					});
				} else {
					console.warn('😪 # findMenuItem not found', uuid);
				}
			}
		});

		return {
			inPageView,

			openingComplete,
			openingAnimationRef,
			handleOpeningComplete
		};
	},
	render() {
		const Navigation = <SmartLayoutC compId="layout_nav" mode="basic" key="layout_nav" />;
		// 开屏动画
		const openingRefSetter = el => (this.openingAnimationRef = el);
		const OpeningAnimationSection = (
			<OpeningAnimation
				ref={openingRefSetter}
				onComplete={this.handleOpeningComplete}
				style={{ display: this.openingComplete ? 'none' : '' }}
			/>
		);
		const PageContainer = <router-view key={this.$route.fullPath} />;

		let layouts = [];
		const initRender = () => {
			if (this.inPageView) {
				layouts = [Navigation, OpeningAnimationSection, PageContainer];
			} else {
				layouts = [PageContainer];
			}
		};
		initRender();

		return <div class="surf-layout">{...layouts}</div>;
	}
};
</script>

<style lang="less" scoped>
.surf-layout {
	background: var(--theme-color);
}
</style>
